var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosshair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 7 0 L 7 2.0253906 C 4.3674121 2.2646453 2.2646453 4.3674121 2.0253906 7 L 0 7 L 0 8 L 2.0253906 8 C 2.2646453 10.632588 4.3674121 12.735355 7 12.974609 L 7 15 L 8 15 L 8 12.974609 C 10.632588 12.735355 12.735355 10.632588 12.974609 8 L 15 8 L 15 7 L 12.974609 7 C 12.735355 4.3674121 10.632588 2.2646453 8 2.0253906 L 8 0 L 7 0 z M 7 3.0507812 L 7 4 L 8 4 L 8 3.0507812 C 10.084817 3.2829831 11.717017 4.9151825 11.949219 7 L 11 7 L 11 8 L 11.949219 8 C 11.717017 10.084817 10.084817 11.717017 8 11.949219 L 8 11 L 7 11 L 7 11.949219 C 4.9151825 11.717017 3.2829831 10.084817 3.0507812 8 L 4 8 L 4 7 L 3.0507812 7 C 3.2829831 4.9151825 4.9151825 3.2829831 7 3.0507812 z",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.f836e82dceca7686833a9e7d1bf81aed.svg";
export { ForwardRef as ReactComponent };